import { FormattedMessage } from '@alltrails/shared/react-intl';
import * as styles from './ExternalPayForm.module.scss';
import payWithPayPalSrc from '../../../../assets/images/pro/pay_with_paypal@2x.png';
import * as formStyles from '../styles/styles.module.scss';
import payWithAppleSrc from '../../../../assets/images/pro/pay_with_apple.svg';

interface Props {
  submitting: boolean;
  paypalHandler: any;
  applePayHandler: any;
  showApplePay: boolean;
}

const ExternalPayForm = ({ submitting, paypalHandler, applePayHandler, showApplePay }: Props) => (
  <div>
    <div className={formStyles.inputItem}>
      <button className={styles.payPalCheckout} disabled={submitting} onClick={paypalHandler} type="button">
        <span className={styles.contents}>
          <FormattedMessage defaultMessage="Checkout with" />
          <img alt="" className={styles.payPalIcon} src={payWithPayPalSrc} />
        </span>
      </button>
    </div>
    {showApplePay && (
      <div className={formStyles.inputItem}>
        <button onClick={applePayHandler} type="button">
          <FormattedMessage defaultMessage="Checkout with" />
          <img alt="" className={styles.payPalIcon} src={payWithAppleSrc} />
        </button>
      </div>
    )}
  </div>
);

export default ExternalPayForm;
